import { createFileRoute } from '@tanstack/react-router';
import { MyChecklistsPage } from '@/features/checklists/pages/my-checklists-page';

export const Route = createFileRoute('/_app/me/checklists')({ component: MyChecklistsPage });
